export const AUTH_USER_TOKEN = "CMMS.Token";
export const AUTH_USER_CLAIMS_TOKEN = "CMMS.UserClaimsToken";

export const CUSTOMER_VERIFIED = "CMMS.CustomerVerification";



// WEBPACK FOOTER //
// ./src/Utils/LocalStorage.ts